/* ⚛ REACT */
import { useState } from "react";

/* 🎨 STYLES */
import { TooltipContainer } from "./styles";

const Tooltip = ({ text, children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <TooltipContainer
      className="relative inline-block"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}

      {visible && (
        <div className="tooltip-box">
          {text}
        </div>
      )}
    </TooltipContainer>
  );
};

export default Tooltip;